<template>
  <div class="ui-screen"
       :style="{ 'webkitTransform': transformation, 'transform': transformation, 'width': screenWidth }"
       @contextmenu="showContextMenu($event)"
  >
    <span><i><span class="display-1">{{ myScreen.label }}</span></i></span>
  </div>
</template>

<script>
  import interact from 'interactjs';

  const DEFAULT_HEIGHT = 50;

  export default {
    name: "Screen",

    props: {
      myScreen: Object,
      bookingMode: Boolean
    },

    computed: {
      screenWidth() {
        return this.myScreen.width + 'px';
      },
      screenHeight() {
        return (this.myScreen.height > 0 ? this.myScreen.height : DEFAULT_HEIGHT) + 'px';
      },
      top() {
        return this.myScreen.y + 'px';
      },
      left() {
        return this.myScreen.x + 'px';
      },
      transformation() {
        return 'translate(' + this.left + ', ' + this.top + ')';
      }
    },

    methods: {
      showContextMenu(event) {
        this.$emit('show-screen-context-menu', event);
      },
      resizeListener (event) {
        // Get coordinates
        let x = (parseFloat(this.myScreen.x) || 0),
          y = (parseFloat(this.myScreen.y) || 0),
          screenWidth = event.rect.width;

        x += event.deltaRect.left;
        y += event.deltaRect.top;

        // Emit the resize/drag move event
        this.$emit('screen-moved', { x: x, y: y, width: screenWidth });
      },
      dragMoveListener (event) {
        // Get coordinates
        let newX = (parseFloat(this.myScreen.x) || 0) + event.dx,
          newY = (parseFloat(this.myScreen.y) || 0) + event.dy;

        // Emit the resize/drag move event
        this.$emit('screen-moved', { x: newX, y: newY });
      }
    },

    mounted() {
      if (! this.bookingMode) {
        interact(this.$el)
          .draggable({
            onmove: this.dragMoveListener,
            restrict: {
              restriction: 'parent',
              elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
            },
          })
          .resizable({
            // resize from all edges and corners
            edges: { left: true, right: true, bottom: false, top: false },

            // keep the edges inside the parent
            restrictEdges: {
              outer: 'parent',
              endOnly: true,
            },

            // minimum size
            restrictSize: {
              min: { width: 115, height: 50 },
            },

            inertia: true,
          })
          .on('resizemove', this.resizeListener);
      }
    }
  }
</script>

<style scoped>
  .ui-screen {
    text-align: center;
    border: solid 2px black;
    position: absolute;

    /* This makes things *much* easier */
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Screen.vue